export default __webpack_public_path__ + "static/media/CaretDown.aa2075cb.svg";